<!--
    file type .....: HTML file: dw-dropdown.component.html
    Created By ....: ianday
    Date ..........: 11/8/23 
-->

<mat-select [id]="_id"
            [(ngModel)]="selectedItem"
            [multiple]="multiSelect"
            ngDefaultControl
            [disabled]="disabled"
            floatLabel="never"
            disableOptionCentering
            [style]="{'width': _controlWidth, 'font-size':_fontSize}"
            [style.backgroundColor]="disabled?'light-gray':'white'"
            panelClass="local-drop-down-panel mat-elevation-z2"
            class="dw-mat-select"
            (keydown)="onDropDownKeyDown($event)"
            (selectionChange)="onDwItemSelected($event)"
            placeholder="{{placeholder}}" type="text">
 <!-- Sticky search bar -->
  <div *ngIf="enableSearch" class="dropdown-search-container" (click)="$event.stopPropagation()">
    <input type="text"
           [(ngModel)]="searchText"
           placeholder="Search..."
           class="dropdown-search-box">
  </div>

  <!-- Actual options -->
  <mat-option *ngFor="let rec of (enableSearch ? filteredData : _dataSource)"
              [value]="rec.id">
    {{ rec.description }}
  </mat-option>
</mat-select>
